import i18n from "@/i18n";
import consts from "@/consts.js";
import datetimeUtils from "@/plugins/datetimeUtils.js";

export default {
    distribution: {
        distribution: {
          id: 4299,
          order_id: 1,
          order_code: "A" + datetimeUtils.formatDateForCode() + "000001",
          distributions_code: "B" + datetimeUtils.formatDateForCode() + "000001-1",
          alliance_business_id: null,
          shop_id: 1,
          shop_user_id: 0,
          distribution_user_id: null,
          delete_flg: false,
          distribution_time: null,
          created_id: 1,
          created: datetimeUtils.formatTime(new Date()),
          modified_id: null,
          modified: datetimeUtils.formatTime(new Date()),
          distribution_center_id: 1,
          stock_area_id: null,
          is_printed: 0,
          logistics_code: null,
          logistics_name: null,
          logistics_link_man: null,
          logistics_price: 0,
          status: 1,
          print_count: 1,
          memo: "",
          shop_distribution_code: null,
          supplier_distribution_code: null,
          shop_account_id: null,
          supplier_account_id: null,
          total_distribution_num: "12.000",
          total_distribution_price: "0.720000",
          stock_id: 1,
          stock_tel: "",
          stock_name: "XX" + i18n.t("Stock.ObjectName"),
          shop: {
            id: 115,
            alliance_business_id: 0,
            price_level_id: null,
            shop_code: "ShopCode001",
            shop_name: "XX" + consts.shopName(),
            material_template_id: 0,
            product_template_id: 0,
            city_1: "010000000000",
            city_2: null,
            city_3: null,
            address: i18n.t("Shop.Fields.shop_address", [consts.shopName()]),
            tel: null,
            fax: null,
            email: null,
            status: 1,
            comment: "",
            activation_code: null,
            pin_code: null,
            equipment_code: null,
            reg_code: null,
            reg_password: null,
            soft_version: null,
            device_cnt: 0,
            reg_flg: 0,
            erp_account: null,
            erp_account_code: null,
            delete_flg: false,
            created_id: null,
            created: datetimeUtils.formatTime(new Date()),
            modified_id: null,
            modified: datetimeUtils.formatTime(new Date()),
            erp_bank: null,
            lng: 113.273,
            lat: 23.098,
            invoice_type: 0,
            invoice_title: null,
            invoice_code: null,
            balance: 474.92,
            sub_account_balance_json: null,
            collect: null,
            order_cycles_code: null,
            shop_pay_setting: null,
            shop_bail: 10000,
            hide_material_price_flg: 0,
            hide_order_price_flg: 0,
            company_name: null,
            national_tax_code: null,
            province_id: null,
            city_id: null,
            area_id: null,
            shop_user: {
              id: 1,
              shop_id: 1,
              login_user_id: "13311113333",
              type: 2,
              name: "姓名",
              identification_num: "",
              tel: "13311113333",
              mobile: null,
              email: null,
              role: 1,
              sex: null,
              delete_flg: false,
              created_id: null,
              created: datetimeUtils.formatTime(new Date()),
              modified_id: null,
              modified: datetimeUtils.formatTime(new Date()),
            },
            template_name: "默认模板",
          },
          distribution_user: null,
          distribution_details: [
            {
              id: 1,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511001",
              material_name: "511001",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511001",
              barcode: "511001",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511001",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511001",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 2,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511002",
              material_name: "511002",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511002",
              barcode: "511002",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511002",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511002",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 3,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511003",
              material_name: "511003",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511003",
              barcode: "511003",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511003",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511003",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 4,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511004",
              material_name: "511004",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511004",
              barcode: "511004",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511004",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511004",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 5,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511005",
              material_name: "511005",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511005",
              barcode: "511005",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511005",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511005",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 6,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511006",
              material_name: "511006",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511006",
              barcode: "511006",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511006",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511006",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 7,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511007",
              material_name: "511007",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511007",
              barcode: "511007",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511007",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511007",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 8,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511008",
              material_name: "511008",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511008",
              barcode: "511008",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511008",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511008",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 9,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511009",
              material_name: "511009",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511009",
              barcode: "511009",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511009",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511009",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 10,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "5110010",
              material_name: "5110010",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "5110010",
              barcode: "5110010",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "5110010",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "5110010",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 11,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511011",
              material_name: "511011",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511011",
              barcode: "511011",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511011",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511011",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 12,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511012",
              material_name: "511012",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511012",
              barcode: "511012",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511012",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511012",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 12,
              cat_sum: 0.72000000000000001,
            },
            {
              id: 13,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511001",
              material_name: "511001",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511001",
              barcode: "511001",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511001",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511001",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 14,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511002",
              material_name: "511002",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511002",
              barcode: "511002",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511002",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511002",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 15,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511003",
              material_name: "511003",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511003",
              barcode: "511003",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511003",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511003",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 16,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511004",
              material_name: "511004",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511004",
              barcode: "511004",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511004",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511004",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 17,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511005",
              material_name: "511005",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511005",
              barcode: "511005",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511005",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511005",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 18,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511006",
              material_name: "511006",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511006",
              barcode: "511006",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511006",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511006",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 19,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511007",
              material_name: "511007",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511007",
              barcode: "511007",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511007",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511007",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 20,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511008",
              material_name: "511008",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511008",
              barcode: "511008",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511008",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511008",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 21,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511009",
              material_name: "511009",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511009",
              barcode: "511009",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511009",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511009",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 22,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "5110010",
              material_name: "5110010",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "5110010",
              barcode: "5110010",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "5110010",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "5110010",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 23,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511011",
              material_name: "511011",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511011",
              barcode: "511011",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511011",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511011",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 24,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511012",
              material_name: "511012",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511012",
              barcode: "511012",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511012",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511012",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 12,
              cat_sum: 0.72000000000000001,
            },
            {
              id: 25,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511001",
              material_name: "511001",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511001",
              barcode: "511001",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511001",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511001",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 26,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511002",
              material_name: "511002",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511002",
              barcode: "511002",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511002",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511002",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 27,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511003",
              material_name: "511003",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511003",
              barcode: "511003",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511003",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511003",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 28,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511004",
              material_name: "511004",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511004",
              barcode: "511004",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511004",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511004",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 29,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511005",
              material_name: "511005",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511005",
              barcode: "511005",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511005",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511005",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 30,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511006",
              material_name: "511006",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511006",
              barcode: "511006",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511006",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511006",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 31,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511007",
              material_name: "511007",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511007",
              barcode: "511007",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511007",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511007",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 32,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511008",
              material_name: "511008",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511008",
              barcode: "511008",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511008",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511008",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 33,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511009",
              material_name: "511009",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511009",
              barcode: "511009",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511009",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511009",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 34,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "5110010",
              material_name: "5110010",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "5110010",
              barcode: "5110010",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "5110010",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "5110010",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 2,
              cat_sum: 0.12000000000000001,
            },
            {
              id: 35,
              distributions_id: 4299,
              material_id: 2486,
              material_code: "511011",
              material_name: "511011",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.1,
              standard_detail_id: 2473,
              out_detail_id: 19138,
              detail_stock_id: "40",
              stock_detail_id: 532,
              stock_batch_code: "5110010120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511011",
              barcode: "511011",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511011",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511011",
              stock_unit_num: "1件",
              sum: 0.1,
              cat_num_sum: 1,
              cat_sum: 0.1,
            },
            {
              id: 36,
              distributions_id: 4299,
              material_id: 2487,
              material_code: "511012",
              material_name: "511012",
              category_code: "040000000000",
              category_rank: 1,
              category_sort: 8,
              category_number: "09",
              category_name: i18n.t("Material.Fields.material_category"),
              distribution_num: 1,
              default_distribution_num: 1,
              memo: "",
              unit: "件",
              price: 0.02,
              standard_detail_id: 2474,
              out_detail_id: 19139,
              detail_stock_id: "40",
              stock_detail_id: 533,
              stock_batch_code: "5110020120210511001",
              production_date: "2021/05/11 00:00:00",
              expired_date: "2021/08/31 00:00:00",
              standard_name: "",
              standard_barcode: "511012",
              barcode: "511012",
              distribution_unit_rate: "1.000",
              default_unit: "件",
              default_unit_rate: "1.000",
              default_unit_barcode: "511012",
              stock_unit: "件",
              stock_unit_rate: "1.000",
              stock_unit_barcode: "511012",
              stock_unit_num: "1件",
              sum: 0.02,
              cat_num_sum: 12,
              cat_sum: 0.72000000000000001,
            },
          ],
          contact_method: "",
          creater_name: "system",
          modifier_name: "system",
          shop_user_name: "姓名",
          distribution_user_name: "",
          actions: { distribute: true, logistic: false },
        },
        order: {
          id: 1,
          order_code: "A20210603000006",
          ext_code: "PS2000121060200023",
          alliance_business_id: null,
          shop_id: 1,
          shop_user_id: 0,
          admin_user: 77,
          status: 4,
          type: 1,
          bill_pay_flg: null,
          price_fix: 0.12,
          price_cut: 0,
          order_price: 0.12,
          add_flg: 0,
          cps_json: [],
          disable_cps: false,
          shop_account_id: null,
          shop_purchase_code: null,
          shop_stock_order_code: null,
          is_cps: false,
          memo: "",
          delete_flg: false,
          created_id: 77,
          created: "2021/06/03 15:08:03",
          modified_id: null,
          modified: "2021/06/18 14:46:01",
          account_memo: "",
          expect_date: null,
          actual_date: "2021/06/03 15:07:00",
          cancel_flg: false,
          print_count: 13,
          error_flg: 0,
          grant_user_id: 77,
          invoice_url: null,
          invoice_type: 0,
          invoice_rate: 0,
          expect_return_price: null,
          remark: null,
          check_price: null,
          order_img: null,
          origin_flg: "001",
          bill_status: null,
          shop: {
            id: 115,
            alliance_business_id: 0,
            price_level_id: null,
            shop_code: "ShopCode001",
            shop_name: "XX" + consts.shopName(),
            material_template_id: 67,
            product_template_id: 0,
            city_1: "010000000000",
            city_2: null,
            city_3: null,
            address: i18n.t("Shop.Fields.shop_address", [consts.shopName()]),
            tel: null,
            fax: null,
            email: null,
            status: 1,
            comment: "",
            activation_code: null,
            pin_code: null,
            equipment_code: null,
            reg_code: null,
            reg_password: null,
            soft_version: null,
            device_cnt: 0,
            reg_flg: 0,
            erp_account: null,
            erp_account_code: null,
            delete_flg: false,
            created_id: null,
            created: "2020/07/16 10:41:13",
            modified_id: null,
            modified: "2021/05/27 14:55:57",
            erp_bank: null,
            lng: 113.273,
            lat: 23.098,
            invoice_type: 0,
            invoice_title: null,
            invoice_code: null,
            balance: 474.92,
            sub_account_balance_json: null,
            collect: null,
            order_cycles_code: null,
            shop_pay_setting: null,
            shop_bail: 10000,
            hide_material_price_flg: 0,
            hide_order_price_flg: 0,
            company_name: null,
            national_tax_code: null,
            province_id: null,
            city_id: null,
            area_id: null,
            alliance_business_shop: {
              id: 181,
              alliance_business_id: 28,
              shop_id: 115,
              alliance_busines: {
                id: 28,
                alliance_business_code: "zx006",
                alliance_business_name: "zx006",
                type: 1,
                check_order_flg: 0,
                rule_flg: 1,
                city_1: "010000000000",
                city_2: null,
                city_3: null,
                address: i18n.t("Shop.Fields.shop_address", [consts.shopName()]),
                tel: null,
                fax: null,
                email: null,
                status: 1,
                seller_price: 1,
                is_confirm_order: 1,
                comment: "",
                delete_flg: false,
                created_id: null,
                created: "2020/11/03 15:03:29",
                modified_id: 1,
                modified: "2020/11/03 15:03:29",
              },
            },
            shop_user: {
              id: 79,
              shop_id: 115,
              login_user_id: "13311113333",
              type: 2,
              name: "姓名",
              identification_num: "",
              tel: "13311113333",
              mobile: null,
              email: null,
              role: 1,
              sex: null,
              delete_flg: false,
              created_id: null,
              created: "2020/07/16 10:41:13",
              modified_id: null,
              modified: "2021/05/10 10:42:51",
            },
            template_name: "默认模板",
          },
          order_extra: null,
          bill: {
            id: 5846,
            bill_code: "M20210603000006",
            bill_type: 101,
            bill_obj_type: 1,
            credential_type: 4,
            fee: 0.12,
            invoice_fee: 0,
            logistics_fee: 0,
            sub_account_pay_json: null,
            shop_id: 115,
            supplier_id: null,
            status: 1,
            org_code: "A20210603000006",
            actual_date: "2021-06-03 15:07",
            delete_flg: 0,
            created_id: 77,
            created: "2021/06/03 15:08:03",
            modified_id: null,
            modified: "2021/06/03 15:09:18",
            pay_flg: 1,
            bill_check_flg: 0,
            org_fee: 0.12,
            bill_type_str: "要货对账单",
            order_type_str: "要货单",
            io_str: "收",
            wait_io_str: "收",
            status_str: "未支付（未对账）",
            status_color: "#1485ee",
            credential_str: "要货出库",
            creater_name: "system",
            modifier_name: "system",
            pay_type_arr: {
              101: "余额",
              102: "微信转账",
              103: "支付宝转账",
              201: "银行转账",
              202: "现金",
              215: "易生退款",
              217: "汇付退款",
            },
            refund_pay_arr: {
              101: "余额",
              102: "微信转账",
              103: "支付宝转账",
              201: "银行转账",
              202: "现金",
            },
            total_price: 0.12,
            cancel_flg: 0,
            actions: {
              complete: true,
              check_bill: true,
              uncheck_bill: false,
              pay: false,
              receive: true,
              credential_refresh: false,
            },
          },
          creater_name: "system",
          modifier_name: "system",
          granter_name: "system",
          admin_user_name: "system",
          shop_user_name: "",
          actions: {
            add: true,
            confirm: false,
            account_edit: false,
            shop_edit: false,
            redeliver: false,
            approve: false,
            cancel: false,
            preprint: false,
            return_add: true,
            return_confirm: false,
            return_edit: false,
            return_redeliver: false,
            return_approve: false,
            return_cancel: false,
          },
        }
    },
}